import styled from 'styled-components';
export const Body = styled.ul `
  display: flex;

  > li + li {
    margin-inline-start: 6px;
  }
`;
export const StarButton = styled.button `
  outline: none;
  transform: scale(${props => (props.isFocused ? '1.1' : '1')});

  &:active {
    transform: scale(0.95);
  }
`;
export const Star = styled.span `
  font-size: ${props => props.starSize ?? '24px'};

  &::after {
    content: ${props => (props.isFilled ? '"★"' : '"☆"')};
  }
`;
//# sourceMappingURL=styles.js.map